// ---------
// FEATURED CATEGORIES FADE-IN "SLIDER"
// ---------

function initProcessBlock() {

    let blocks = document.querySelectorAll(".js-block-process");



    if (blocks.length == 0) {
        return;
    }

    blocks.forEach((block) => {
        setupBlock(block);
    });

    function setupBlock(block) {
        let buttons = block.querySelectorAll("[data-next]")
        let listeners = block.querySelectorAll("[data-listener]")

        let left = block.querySelector(".js-left");
        let right = block.querySelector(".js-right");

        let maxState = listeners.length - 1;
        let state = 0;

        function setState(desiredState) {
            if (desiredState > maxState) desiredState = 0; //check if overflowing and go back home
            if (desiredState < 0) desiredState = maxState; //check if overflowing and go back home


            listeners.forEach(el => {
                if (parseInt(el.dataset.listener) == desiredState) {
                    el.classList.add("is-active")
                } else {
                    el.classList.remove("is-active")
                }
            });

            state = desiredState;
            updateArrows(state);
        }

        function updateArrows(state) {
            left.classList.remove("is-disabled");
            right.classList.remove("is-disabled");
            if (state == maxState) right.classList.add("is-disabled");
            if (state == 0) left.classList.add("is-disabled");
        }
        updateArrows(state);





        if (left) {
            left.addEventListener("click", () => { setState(state - 1) })
        }
        if (right) {
            right.addEventListener("click", () => { setState(state + 1) })
        }

        buttons.forEach(el => {
            el.addEventListener("click", (e) => {
                setState(parseInt(e.target.closest("[data-next]").dataset.next));
            })
        });


        function measureHeights() {
            const measureBox = block.querySelector('.js-measurebox')
            // Get all the heading elements
            const headings = measureBox.querySelectorAll('.js-measure-heading');
            // Get all the content elements
            const contents = measureBox.querySelectorAll('.js-measure-content');

            // Initialize variables to hold the total heading height and maximum content height
            let totalHeadingHeight = 0;
            let maxContentHeight = 0;

            // Iterate through the headings and add their heights
            headings.forEach((heading) => {
                totalHeadingHeight += heading.offsetHeight;
            });

            // Iterate through the content elements and find the maximum height
            contents.forEach((content) => {
                const height = content.offsetHeight;
                content.parentElement.style.setProperty('--maxHeight', `${height}px`);
                if (height > maxContentHeight) {
                    maxContentHeight = height;
                }
            });

            // Add the total heading height to the maximum content height
            const totalHeight = totalHeadingHeight + maxContentHeight;
            measureBox.style.height = (totalHeight) + "px";
        }

        // Debounce function
        function debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        measureHeights()

        let previousWindowWidth = window.innerWidth;

        // Resize handler with the logic to execute
        const resizeHandler = () => {
            const newWindowWidth = window.innerWidth;

            // Check if the window's width has changed
            if (newWindowWidth !== previousWindowWidth) {
                // Run the measureHeights function if the width has changed
                measureHeights();

                // Update the previousWindowWidth with the new width
                previousWindowWidth = newWindowWidth;
            }
        };

        // Debounced resize handler
        const debouncedResizeHandler = debounce(resizeHandler, 100);

        // Adding the event listener with the debounced handler
        window.addEventListener('resize', debouncedResizeHandler, { passive: true });

    }

}

export { initProcessBlock }